module.exports = __webpack_public_path__ + "Roboto-700.ad97d029a11d8b396920.ttf";


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src634836211/src/src/assets/fonts/roboto/fonts/Roboto-700/Roboto-700.ttf
// module id = ../../../../../src/assets/fonts/roboto/fonts/Roboto-700/Roboto-700.ttf
// module chunks = main styles